import fp from "lodash/fp";

import { mapSoftwareOptionsFileBuildOnly } from "hooks";

export default function mapSoftwareOptionsFileBuildOnlyForm(formValues) {
	if (fp.isEmpty(formValues)) return;
	const mappedValues = {
		softwareOptionDefaults: mapSoftwareOptionsFileBuildOnly(formValues),
	};

	return mappedValues;
}
